import apiClient from './client';

export const fetchBackendVersion = async (): Promise<string> => {
  const { data } = await apiClient.get<{ version: string }>('/version');
  return data.version;
};
